import { formatMoney } from "@justhome/common";
import { Skeleton } from "@justhome/react-ui";
import useLocale from "@lib/hooks/useLocale";
import clsx from "clsx";
import Image from "next/image";
import { FC } from "react";

interface Property {
  title?: string;
  postalCode?: string;
  city?: string;
  purchasePrice?: number;
  imageUrl?: string;
}

interface PropertyCardProps {
  property?: Property;
  isLoading: boolean;
  className?: string;
}

const PropertyCard: FC<PropertyCardProps> = ({
  property,
  isLoading,
  className,
}) => {
  const locale = useLocale();
  return (
    <section
      className={clsx(
        "flex overflow-hidden rounded-m border border-neutral-50 w-full",
        className,
      )}
    >
      <div className="w-[140px] m:min-h-[200px] m:w-[300px] relative flex-none">
        <Skeleton
          width="100%"
          height="100%"
          className="absolute inset-none rounded-none"
          isLoading={isLoading}
        >
          {property?.imageUrl && (
            <Image
              loader={({ src }) => src}
              src={property.imageUrl}
              fill
              alt=""
              className="object-cover"
            />
          )}
        </Skeleton>
      </div>
      <div className="p-3xs m:p-3s flex flex-col grow">
        <h3 className="text-app-body-1 m:text-app-h2 mb-xs">
          <Skeleton isLoading={isLoading} height={24} width="100%">
            {property?.title}
          </Skeleton>
        </h3>
        <Skeleton isLoading={isLoading} height={20} width={200}>
          <p className="text-app-body-2 m:text-app-body text-opacity-60 text-neutral-675">
            {property?.postalCode}, {property?.city}
          </p>
        </Skeleton>
        <Skeleton
          className="mt-auto pt-m"
          isLoading={isLoading}
          height={24}
          width={200}
        >
          {property?.purchasePrice && (
            <p className="text-app-body-1 m:text-app-h2 pt-m mt-auto">
              {formatMoney(property.purchasePrice, true, locale)}
            </p>
          )}
        </Skeleton>
      </div>
    </section>
  );
};

export default PropertyCard;
